import { render, staticRenderFns } from "./top-links-card.vue?vue&type=template&id=d8665528&scoped=true&"
import script from "./top-links-card.vue?vue&type=script&lang=js&"
export * from "./top-links-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8665528",
  null
  
)

export default component.exports